import { Component } from '@angular/core'

@Component({
  selector: 'my-live-documentation-link',
  templateUrl: './live-documentation-link.component.html',
  styleUrls: [ ]
})
export class LiveDocumentationLinkComponent {

}
